import type { Logger } from '@zg-rentals/logger-base';
import type { CountOptions, MeasureOptions } from './baseMonitor';
import type { StatController } from './statController';

export interface Plugin {
  pluginName: string;
  logger?: Logger;
  stats?: StatController;
  increment?: (options: CountOptions) => void;
  gauge?: (options: MeasureOptions) => void;
  onInitialize(increment: (i: CountOptions) => void, gauge: (g: MeasureOptions) => void, logger?: Logger): void;
}

export interface MonitorPluginInterface {
  pluginName: string;
  logger?: Logger;
}

export abstract class MonitorPlugin {
  readonly pluginName: string;
  logger?: Logger;
  stats?: StatController;
  increment?: (options: CountOptions) => void;
  gauge?: (options: MeasureOptions) => void;

  abstract onInitialize(
    increment: (i: CountOptions) => void,
    gauge: (g: MeasureOptions) => void,
    logger?: Logger,
  ): void;

  constructor({ pluginName, logger }: MonitorPluginInterface) {
    this.pluginName = pluginName;
    this.logger = logger;
  }
}
